import { pxToRem } from '../../../../utils';
export default (function (siteVariables) {
  return {
    rootBackground: siteVariables.colors.white,
    rootBorderRadius: pxToRem(3),
    rootWidth: '50vw',
    rootPadding: "".concat(pxToRem(27), " ").concat(pxToRem(32), " ").concat(pxToRem(20), " ").concat(pxToRem(32)),
    contentMargin: "0 0 ".concat(pxToRem(20), " 0"),
    boxShadow: siteVariables.shadowLevel4,
    foregroundColor: siteVariables.colors.grey[900],
    headerFontSize: siteVariables.fontSizes.large,
    headerFontWeight: siteVariables.fontWeightBold,
    headerMargin: "0 0 ".concat(pxToRem(8), " 0"),
    overlayBackground: 'rgba(37, 36, 36, .75)',
    // todo: update to a palette value when daisy has mapped one
    overlayZIndex: siteVariables.zIndexes.overlay,
    headerActionMargin: "".concat(pxToRem(-3), " ").concat(pxToRem(-8), " 0 0")
  };
});